var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveredsm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92103 5.25792C4.88988 3.8596 5.13078 1.93319 6.42806 0.818513L10.3628 6.15392C8.88627 7.02535 6.95225 6.65618 5.9209 5.25802L5.92103 5.25792ZM4.63397 11.6927V13.5119C4.63397 14.1588 5.56055 14.1708 5.56055 13.4994V9.80066L6.45 9.13226C6.81028 8.86143 6.18615 7.95691 5.79758 8.23774C5.0986 8.74292 4.39981 9.24811 3.70082 9.75329C4.13993 10.323 4.62136 10.9966 4.63397 11.6928V11.6927ZM1.63703 9.90496C1.84755 10.1905 2.25746 10.2548 2.54673 10.0468L6.99626 6.84911C5.75498 6.463 4.69343 5.02397 4.71687 3.75858L0.267596 6.95631C-0.0217772 7.16434 -0.0869071 7.56728 0.123606 7.85269L1.63703 9.90496ZM6.91605 0.468806L10.8508 5.80421C12.1481 4.68954 12.3892 2.76303 11.3579 1.3648C10.3267 -0.0336243 8.39276 -0.402795 6.91603 0.468806H6.91605Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveredsm);
export default __webpack_public_path__ + "static/media/liveredsm.58da2f75cc50ded1f5d6b4496253ceb4.svg";
export { ForwardRef as ReactComponent };